import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const login = async (email, password) => {
  if (!email) {
    throw new Error("Email is required");
  }

  if (!password) {
    throw new Error("Password is required");
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const hasNoSpaces = !/\s/.test(email);
  if (!emailRegex.test(email) || !hasNoSpaces) {
    throw new Error("Email is not valid");
  }

  axios.defaults.withCredentials = true;
  try {
    const response = await axios.post(`${API_URL}/loginUser`, {
      email,
      password,
    });
    if (response.data.user) {
      localStorage.setItem("user", JSON.stringify(response.data.user));
    }
    console.log(response.data);
    return { success: true, user: response.data.user };
  } catch (error) {
    console.error(
      "Error during login:",
      error.response ? error.response.data : error.message
    );
    if (error.response && error.response.status === 401) {
      // L'utente non è autenticato
      return { success: false, message: "Email or password incorrect" };
    } else if (error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      console.log(error);
      return { success: false, message: "An error occurred during login" };
    }
  }
};

export const registration = async (firstName, lastName, email, password) => {
  if (!email) {
    throw new Error("Email is required");
  }

  if (!password) {
    throw new Error("Password is required");
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const hasNoSpaces = !/\s/.test(email);
  if (!emailRegex.test(email) || !hasNoSpaces) {
    throw new Error("Email is not valid");
  }

  if (firstName.length < 2) {
    throw new Error("First name must be at least 2 characters long");
  }

  if (lastName.length < 2) {
    throw new Error("Last name must be at least 2 characters long");
  }

  if (
    !/[A-Z]/.test(password) || // Verifica almeno una maiuscola
    !/[a-z]/.test(password) || // Verifica almeno una minuscola
    !/\d/.test(password) || // Verifica almeno un numero
    !/[!@#$%^&*\.]/.test(password) // Verifica almeno un carattere speciale
  ) {
    throw new Error(
      "Password must be at least 8 characters long, with at least one uppercase letter, one lowercase letter, one number, and one special character"
    );
  }

  axios.defaults.withCredentials = true;

  try {
    const response = await axios.post(`${API_URL}/register`, {
      firstName,
      lastName,
      email,
      password,
    });

    //login(email, password);

    return { response: response.data, message: "success" };
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const logout = async () => {
  axios.defaults.withCredentials = true;
  try {
    const response = await axios.get(`${API_URL}/logout`, {});
    localStorage.clear();
    return true;
  } catch (err) {
    console.log(err);
    return Promise.reject(err);
  }
};

export const deleteAccount = async () => {
  try {
    const response = await axios.get(`${API_URL}/deleteUser`, {});
    localStorage.clear();
    return true;
  } catch (err) {
    console.log(err);
    return Promise.reject(err);
  }
};

export const getCurrentUser = async () => {
  axios.defaults.withCredentials = true;
  console.log("getCurrentUser");
  try {
    const response = await axios.get(`${API_URL}/me`, {});
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const verifyLogin = async () => {
  axios.defaults.withCredentials = true;
  try {
    const response = await axios.get(`${API_URL}/api/verifyLogin`, {});
    console.log(response.data);

    return response.data;
  } catch (error) {
    console.log(error);
    if (error.response && error.response.status === 401) {
      // L'utente non è autenticato
      return false;
    }
  }
};

export const updateUserData = async (
  nome,
  cognome,
  email,
  indirizzo,
  num_tel
  /*regione,
  comune,
  via,
  civico*/
) => {
  axios.defaults.withCredentials = true;

  try {
    const response = await axios.post(`${API_URL}/updateUserData`, {
      nome,
      cognome,
      email,
      indirizzo,
      num_tel,
    });
    return true;
  } catch (error) {
    console.log(error);
    if (error.response && error.response.status === 401) {
      // L'utente non è autenticato
      return false;
    }
  }
};

export const requestRetrievePassword = async (email) => {
  //console.log("requestRetrievePassword");
  try {
    const response = await axios.post(`${API_URL}/requestRetrievePassword`, {
      email,
    });
    return true;
  } catch (error) {
    console.log(error);
    if (error.response && error.response.status === 401) {
      // L'utente non è autenticato
      return false;
    }
  }
};

export const resetPassword = async (token, password) => {
  console.log("TOKEN: ", token);
  console.log("PASSWORD: ", password);
  console.log("resetPassword");

  if (
    !/[A-Z]/.test(password) || // Verifica almeno una maiuscola
    !/[a-z]/.test(password) || // Verifica almeno una minuscola
    !/\d/.test(password) || // Verifica almeno un numero
    !/[!@#$%^&*\.]/.test(password) // Verifica almeno un carattere speciale
  ) {
    throw new Error(
      "La password deve contenere almeno 8 caratteri, una lettera maiuscola, una lettera minuscola, un numero e un carattere speciale"
    );
  }

  try {
    const response = await axios.post(`${API_URL}/reset-password`, {
      password,
      token,
    });
    console.log("FATTO");
    return response;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("TOKEN SCADUTO");
      console.log(error.response.data);
      return error.response;
    }
    return false;
  }
};

export const addToCart = async (id_prodotto, quantity) => {
  axios.defaults.withCredentials = true;
  console.log("addToCart", quantity);

  try {
    const response = await axios.post(`${API_URL}/addToCart`, {
      id_prodotto,
      quantity,
    });
    return true;
  } catch (error) {
    console.log(error);
    if (error.response && error.response.status === 401) {
      console.log("NON AUTENTICATO");
      return false;
    }
  }
};

export const updateCart = async (id_prodotto, quantity) => {
  console.log("PRODOTTO API:", id_prodotto);
  console.log("QUANTITA':", quantity);
  axios.defaults.withCredentials = true;
  try {
    const response = await axios.post(`${API_URL}/updateCart`, {
      id_prodotto,
      quantity,
    });
    return true;
  } catch (error) {
    console.log(error);
    if (error.response && error.response.status === 401) {
      return false;
    }
  }
};
export const removeFromCart = async (id_prodotto) => {
  axios.defaults.withCredentials = true;

  try {
    const response = await axios.post(`${API_URL}/removeFromCart`, {
      id_prodotto,
    });
    return true;
  } catch (error) {
    console.log(error);
    if (error.response && error.response.status === 401) {
      // L'utente non è autenticato
      return false;
    }
  }
};

export const retrieveFromCart = async () => {
  axios.defaults.withCredentials = true;
  try {
    const response = await axios.get(`${API_URL}/retrieveCart`, {});
    console.log(response);
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.response && error.response.status === 401) {
      // L'utente non è autenticato
      return false;
    }
  }
};

export const checkCoupon = async (coupon) => {
  axios.defaults.withCredentials = true;
  try {
    const response = await axios.post(`${API_URL}/checkCoupon`, { coupon });
    return response.data;
  } catch (error) {
    console.log("ERROR:", error);

    if (error.response) {
      // Gestione specifica per diversi stati di errore
      if (error.response.status === 401) {
        // L'utente non è autenticato
        return { valid: false, message: "Non autenticato" };
      } else if (error.response.status === 400) {
        // Coupon non valido o errore generico
        return {
          valid: false,
          message: error.response.data.message || "Coupon non valido",
        };
      }
    }

    // Gestione di errori imprevisti
    return { valid: false, message: "Errore durante la verifica del coupon" };
  }
};

export const subscribe = async (id_prodotto, selectedOption, coupon) => {
  console.log("subscribe");
  console.log("id_prodotto: ", id_prodotto);
  try {
    const response = await axios.post(`${API_URL}/subscribe`, {
      id_prodotto,
      selectedOption,
      coupon,
    });
    return true;
  } catch (error) {
    console.log(error);
    if (error.response && error.response.status === 401) {
      // L'utente non è autenticato
      return false;
    }
  }
};

export const getSubscriptions = async () => {
  axios.defaults.withCredentials = true;
  try {
    const response = await axios.get(`${API_URL}/retrieve-subscription`, {});
    console.log("RESPONSE API: ", response);
    return response.data;
  } catch (error) {
    console.log("RESPONDE API error", error);

    if (error.response && error.response.status === 401) {
      // L'utente non è autenticato
      return false;
    }
  }
};

export const sendGift = async (data) => {
  axios.defaults.withCredentials = true;
  console.log("DATA: ", data);

  const response = await axios.post(`${API_URL}/sendGift`, {
    data,
  });
  return response;
};

export const getOrders = async () => {
  axios.defaults.withCredentials = true;
  try {
    const response = await axios.get(`${API_URL}/retrieveOrders`, {});
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.response && error.response.status === 401) {
      // L'utente non è autenticato
      return false;
    }
  }
};

export const getOrderDetails = async (id_ordine) => {
  console.log("ID ORDINE:", id_ordine);
  axios.defaults.withCredentials = true;
  try {
    const response = await axios.post(`${API_URL}/retrieveOrderDetails`, {
      id_ordine,
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.response && error.response.status === 401) {
      // L'utente non
    }
  }
};
